export function callAll(...fns) {
    return function callAllFns() {
        const arg = arguments;
        fns.forEach((fn) => typeof fn === 'function' && fn.apply(null, arg));
    };
}
export function noop() { }
//# sourceMappingURL=fn-lib.js.map